var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2521.23 1232.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#radial-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 842.55,
    cy: 614.66,
    fx: 842.55,
    fy: 614.66,
    r: 1067.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#f89b46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f56b42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#f44d40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f44240"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 2521.23,
    height: 1232.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGradient);
export default __webpack_public_path__ + "static/media/bg-gradient.4f2c5e2d8608b706cd2629f8bbdb285a.svg";
export { ForwardRef as ReactComponent };